import { render, staticRenderFns } from "./MasonryGallery.vue?vue&type=template&id=1f8e531d&scoped=true&"
import script from "./MasonryGallery.vue?vue&type=script&lang=js&"
export * from "./MasonryGallery.vue?vue&type=script&lang=js&"
import style0 from "./MasonryGallery.vue?vue&type=style&index=0&id=1f8e531d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e531d",
  null
  
)

export default component.exports